// Base item templates. See docs/04-equipment-craft §4.3 / §4.3.1 / §4.5.1
// and docs/adr/0016-c6-base-items.md.
//
// `ItemBase` is the static template per (slot × baseKind × tier). Item
// instances (`Item` in items.ts) reference an `ItemBase` via `baseId` and
// add rarity / affixes / itemSkills / behaviorRule on top.
export const ITEM_BASE_TIERS = [1, 2, 3, 4, 5];
/**
 * Weapon kinds populated by ADR 0016. Nine kinds cover the five combat
 * archetypes (Melee / Ranged / Magic) per docs/04 §4.5.1.
 */
export const WEAPON_KINDS = [
    'sword',
    'axe',
    'spear',
    'bow',
    'staff',
    'dagger',
    'mace',
    'scythe',
    'wand',
];
/**
 * Armor kinds populated by ADR 0016. One kind per body slot (helmet / chest /
 * gloves / boots / belt / amulet / ring / cloak).
 */
export const ARMOR_KINDS = [
    'helmet',
    'chest',
    'gloves',
    'boots',
    'belt',
    'amulet',
    'ring',
    'cloak',
];
/** Off-hand kinds populated by ADR 0016 (Tank / Magic / Ranged variants). */
export const OFF_HAND_KINDS = ['shield', 'focus', 'quiver'];
/** Tier ↔ ilvl correspondence pinned by docs/04 §4.3.1. */
export const TIER_ILVL_RANGE = {
    1: { min: 1, max: 30 },
    2: { min: 30, max: 60 },
    3: { min: 60, max: 120 },
    4: { min: 120, max: 400 },
    5: { min: 400, max: Number.POSITIVE_INFINITY },
};
/**
 * Weapon baseDmg multiplier per tier, pinned by docs/04 §4.3.1 (Tier 5 = ×3
 * vs Tier 1). Armor / off-hand defensive values use the same ratio for
 * design consistency.
 */
export const TIER_BASE_MULTIPLIER = {
    1: 1.0,
    2: 1.4,
    3: 1.8,
    4: 2.4,
    5: 3.0,
};
//# sourceMappingURL=item-bases.js.map